import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from "react";
import loader, { PageResourceStatus } from "./loader";
import shallowCompare from "shallow-compare";
let EnsureResources = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(EnsureResources, _React$Component);
  function EnsureResources(props) {
    var _this;
    _this = _React$Component.call(this) || this;
    const {
      location,
      pageResources
    } = props;
    _this.state = {
      location: _objectSpread({}, location),
      pageResources: pageResources || loader.loadPageSync(location.pathname)
    };
    return _this;
  }
  EnsureResources.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    let {
      location
    } = _ref;
    if (prevState.location.href !== location.href) {
      const pageResources = loader.loadPageSync(location.pathname);
      return {
        pageResources,
        location: _objectSpread({}, location)
      };
    }
    return {
      location: _objectSpread({}, location)
    };
  };
  var _proto = EnsureResources.prototype;
  _proto.loadResources = function loadResources(rawPath) {
    loader.loadPage(rawPath).then(pageResources => {
      if (pageResources && pageResources.status !== PageResourceStatus.Error) {
        this.setState({
          location: _objectSpread({}, window.location),
          pageResources
        });
      } else {
        window.history.replaceState({}, "", location.href);
        window.location = rawPath;
      }
    });
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // Always return false if we're missing resources.
    if (!nextState.pageResources) {
      this.loadResources(nextProps.location.pathname);
      return false;
    }
    if (process.env.BUILD_STAGE === "develop" && nextState.pageResources.stale) {
      this.loadResources(nextProps.location.pathname);
      return false;
    }

    // Check if the component or json have changed.
    if (this.state.pageResources !== nextState.pageResources) {
      return true;
    }
    if (this.state.pageResources.component !== nextState.pageResources.component) {
      return true;
    }
    if (this.state.pageResources.json !== nextState.pageResources.json) {
      return true;
    }
    // Check if location has changed on a page using internal routing
    // via matchPath configuration.
    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
      return true;
    }
    return shallowCompare(this, nextProps, nextState);
  };
  _proto.render = function render() {
    if (process.env.NODE_ENV !== "production" && !this.state.pageResources) {
      throw new Error("EnsureResources was not able to find resources for path: \"" + this.props.location.pathname + "\"\nThis typically means that an issue occurred building components for that path.\nRun `gatsby clean` to remove any cached elements.");
    }
    return this.props.children(this.state);
  };
  return EnsureResources;
}(React.Component);
export default EnsureResources;